import { render, staticRenderFns } from "./TenderEditTabEvaluations.vue?vue&type=template&id=cbee1452&"
import script from "./TenderEditTabEvaluations.vue?vue&type=script&lang=js&"
export * from "./TenderEditTabEvaluations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports